import { useState } from 'react';
import type { WidgetPreviewConfig } from './types';
import { EchoLogo } from './widget-icons';

interface WidgetAvatarProps {
  appearance: WidgetPreviewConfig['appearance'];
  className?: string;
  size: number;
}

export const WidgetAvatar = ({ appearance, className, size }: WidgetAvatarProps) => {
  const [failedUrl, setFailedUrl] = useState<string | null>(null);
  const customUrl = appearance.widgetIcon.customUrl;
  const showCustom =
    appearance.widgetIcon.type === 'custom' && Boolean(customUrl) && customUrl !== failedUrl;

  if (showCustom) {
    return (
      <img
        src={customUrl || undefined}
        alt=""
        width={size}
        height={size}
        className={className}
        onError={() => setFailedUrl(customUrl)}
      />
    );
  }

  return <EchoLogo className={className} size={size} />;
};
